"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.svgWidth = void 0;
var svgWidth = function (widthWithUnit, svgViewBoxWidth, svgViewBoxHeight) {
    var ratio = Number((svgViewBoxHeight / svgViewBoxWidth).toFixed(2)) + 0.01;
    return "\n    min-width: ".concat(widthWithUnit, ";\n    width: ").concat(widthWithUnit, ";\n    max-height: calc(").concat(ratio, " * ").concat(widthWithUnit, ");\n  ");
};
exports.svgWidth = svgWidth;
